import WaitManager from '@/services/waitManager';
import ConfirmationTypes from '@/constants/confirmationTypes';
import messageDefinitions from './message-definitions.json';

export const messages = [];

Object.freeze(ConfirmationTypes);

const listeners = [];

const DEFAULT_MESSAGE_TYPE = 'info';
let messageId = 0;

function removeMessage(message) {
  messages.splice(messages.indexOf(message), 1);
}

class Message {
  constructor(config) {
    messageId += 1;
    this.id = messageId;
    if (typeof config !== 'string') {
      this.configObjectHandler(config);
    } else {
      this.configTypeStringHandler(config);
    }

    this.waitManager = new WaitManager();
    this.waiter = this.waitManager.waiter;
  }

  // Confirma a mensagem.
  accept(...args) {
    this.waitManager.accept(...args);
    removeMessage(this);
  }

  // Rejeita a mensagem.
  reject = (...args) => {
    this.waitManager.reject(...args);
    removeMessage(this);
  }

  configObjectHandler(config) {
    if (config.code) {
      this.code = config.code.toUpperCase();
      this.title = config.title || (messageDefinitions[this.code].hasTitle
        ? `messages.${this.code.toUpperCase()}.title` : null);
      this.message = config.message || `messages.${this.code.toUpperCase()}.message`;
      this.confirmation = config.confirmation == null
        ? messageDefinitions[this.code].options : config.confirmation;
      this.confirmationHandler();
    } else {
      this.title = config.title;
      this.message = config.message;
      this.confirmation = config.confirmation;
    }
    this.titleParams = config.titleParams;
    this.messageParams = config.messageParams;
    this.type = config.type || DEFAULT_MESSAGE_TYPE;
    this.viewOptions = config.viewOptions || {};
  }

  confirmationHandler() {
    if (this.confirmation === 'OK') {
      this.confirmation = false;
    }
  }

  configTypeStringHandler(config) {
    this.message = config;
    this.title = null;
    this.type = DEFAULT_MESSAGE_TYPE;
    this.confirmation = false;
  }
}

function pushMessage(message) {
  messages.push(message);
  listeners.forEach(listener => listener(message));
}

export function show(message) {
  const messageInstance = new Message(message);
  pushMessage(messageInstance);
  return messageInstance.waiter;
}

export function confirm(message) {
  const messageInstance = new Message(message);
  messageInstance.confirmation = messageInstance.confirmation != null
    ? messageInstance.confirmation
    : true;
  pushMessage(messageInstance);
  return messageInstance.waiter;
}

export function onNewMessage(listener) {
  listeners.push(listener);
  return () => listeners.splice(listeners.indexOf(listener), 1);
}
